export type UsageRight = {
  id: string;
  organizationId: string;
  cartridgeVariantId: string;
  cartridgeName: string;
  cartridgeVariantName: string;
  state: UsageRightState;
  paymentModel: UsageRightPaymentModel;
  boughtAt: Date;
  validityPeriodStart: Date;
  validityPeriodEnd: Date;
};

export enum UsageRightState {
  BOOKED = 'BOOKED',
  SUSPENDED = 'SUSPENDED',
  STOPPED = 'STOPPED',
}

export enum UsageRightActivationState {
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  ACTIVE = 'ACTIVE',
  ACCEPTED = 'ACCEPTED',
  INACTIVE = 'INACTIVE',
  CANCELLED = 'CANCELLED',
  UPGRADED = 'UPGRADED',
  UPGRADE_IN_PROGRESS = 'UPGRADE_IN_PROGRESS',
  ENDED = 'ENDED',
}

export enum UsageRightPaymentModel {
  SUBSCRIPTION = 'SUBSCRIPTION',
  FIXED_PRICE = 'FIXED_PRICE',
  PRICE_SCALE_PER_UNIT = 'PRICE_SCALE_PER_UNIT',
  PRICE_LEVEL_PER_UNIT = 'PRICE_LEVEL_PER_UNIT',
  STAGGERED_FIXED_PRICE = 'STAGGERED_FIXED_PRICE',
}

export type CartridgeDto = {
  id: string;
  name: string;
  description: string;
  usageRightActive?: boolean;
  validityPeriodEnd?: Date;
};
